const capitalizedString = (string) => string.charAt(0).toUpperCase() + string.slice(1)

export default capitalizedString
